export const view = (state = null, action) => {
    switch (action.type) {
        case 'VIEW_SET':
            return action.view;
        default:
            return state
    }
};
